import React, { useRef, useState } from "react"
import { useQuery } from "@tanstack/react-query"
import {
  ADMIN_PEOPLE_ENDPOINTS,
  adminPeopleService,
} from "services/adminPeopleService"
import { useLocation } from "react-router-dom"
import { LoadingIndicatorWhite } from "components/custom/LoaderWhite"
import { Button } from "components"
import ReactToPrint from "react-to-print"
import ComponentToPrint from "pages/employee-dashboard/payslip/component/ComponentToPrint"
import DashboardWrapper from "components/new-stuff/ui/DashboardWrapper"
import EmailPayslipModal from "./component/EmailPayslipModal"
import { IPayslipDetailedRes } from "pages/employee-dashboard/payslip/interface/Payslip"

const EmployeeViewPayslip: React.FC<{}> = () => {
  const myParam = useLocation().search

  const x = new URLSearchParams(myParam).get("x")

  const id = new URLSearchParams(myParam).get("id")
  const componentRef: any = useRef()
  const [showEmailModal, setShowEmailModal] = useState(false)
  const { isLoading: isPayslipLoading, data } = useQuery<IPayslipDetailedRes>({
    queryKey: [ADMIN_PEOPLE_ENDPOINTS.VIEW_ADMIN_PAYSLIP_DETAIL, id, x],
    queryFn: () =>
      adminPeopleService.viewAdminPayslipDetail(id as string, x as string),
  })

  return (
    <DashboardWrapper>
      <div className="relative ">
        <div className="flex items-center justify-between mb-8">
          <h6 className=" text-bluesubtext text-lg font-medium">
            Employee Payslip
          </h6>

          <div className="flex justify-center items-center gap-4">
            {data && (
              <Button
                color="primary"
                title="Download"
                onClick={() => {
                  setShowEmailModal(true)
                }}
              >
                Email
              </Button>
            )}
            {data && componentRef && (
              <ReactToPrint
                trigger={() => (
                  <Button
                    color="primary"
                    title="Download"
                  >
                    Download
                  </Button>
                )}
                content={() => componentRef.current}
                documentTitle={`${data?.data?.download_title}-payslips.pdf`}
              />
            )}
          </div>
        </div>
        <>
          {isPayslipLoading ? (
            <div className="h-screen flex w-full justify-center items-center">
              <LoadingIndicatorWhite />
            </div>
          ) : (
            <ComponentToPrint
              ref={componentRef}
              data={data?.data}
            />
            // <div
            //   className=" pb-40"
            //   id="payslip"
            // >
            //   <PayslipTemplate data={data} />
            // </div>
          )}
        </>
        {showEmailModal && (
          <EmailPayslipModal
            payrollId={id || ""}
            personId={data?.data?.person_id || ""}
            closeModal={() => setShowEmailModal(false)}
          />
        )}
      </div>
    </DashboardWrapper>
  )
}
export default EmployeeViewPayslip
type IViewPaySlipRes = IBaseRes<IViewPaySlip>
interface IViewPaySlip {
  person_id: string
  first_name: string
  last_name: string
  full_name: string
  currency_symbol: string
  payroll_month: string
  pay_period: string
  employer_address_line_1: string
  employer_address_line_2: string
  employee_address_line_1: string
  employee_address_line_2: string
  display_ytd: string
  employer_name?: null
  employer_logo_url?: null
  total_earning: string
  total_deduction: string
  total_contribution: string
  download_title: string
  earnings?:
    | IViewPaySlipEarningsEntityOrDeductionsEntityOrContributionsEntity[]
    | null
  deductions?:
    | IViewPaySlipEarningsEntityOrDeductionsEntityOrContributionsEntity[]
    | null
  contributions?:
    | IViewPaySlipEarningsEntityOrDeductionsEntityOrContributionsEntity[]
    | null
  summary: IViewPaySlipSummary
}
interface IViewPaySlipEarningsEntityOrDeductionsEntityOrContributionsEntity {
  description: string
  current: string
  ytd: string
}
interface IViewPaySlipSummary {
  earnings: string
  earnings_ytd: string
  deductions: string
  deductions_ytd: string
  net_pay: string
  net_pay_ytd: string
}
